<template>
    <div class="row" Id="ScannedSkus">
        <div class="col-12" :key='updateInd'>
            <div class='row divider'>
                <div class='col-12'>
                    <h3>Items Scanned in Session</h3>
                </div>
            </div>
            <div class="itemRow" v-for="(item, index) in itemsScanned" :key='index'>
                <ScannedItem
                    :sku='item.sku'
                    :imgsrc='item.img'
                    :upc='item.UPC'
                    :desc='item.description'
                    :position='index'
                    :picked='item.selected'
                    @select-item="selectItem"
                />
            </div>
             <div class="row mb-3 text-center">
                    <div class="col-6 offset-3 mt-2">
                        <button type="button" class="btn btn-secondary btn-sm btn-clear-selected btn-unpick" @click.prevent="clearSelected" :disabled="unpickDisabled">
                            SHORT SHIP ITEM
                        </button>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-10 offset-1">
                        <button type="button" class="btn btn-primary" @click.prevent="$emit('set-selected', 'Pick By Bin')">
                            Return to Pick by Bin
                        </button>
                    </div>
                </div>
        </div>
    </div>
</template>
<script>
import ScannedItem from './ScannedItem'
export default {
    name: 'scannedSkus',
    components:{
        ScannedItem
    },
    data() {
      return {
        itemsScanned: this.$store.getters["ProductCollection/scannedCollection"],
        selectedItems:[],
        unpickDisabled: this.listEmpty,
        division: this.$store.getters['PowerScan/division'],
        updateInd: 0
      }
    },
    mounted(){
        this.getSelected()
    },
    computed:{
        listEmpty(){
            return this.selectedItems.length == 0 ? true : false
        },
        selectedSite(){
            return this.$store.getters['PowerScan/selectedSite'];
        },
        currentSite(){
            return this.$store.getters['PowerScan/currentSite'];
        }
    },
    methods:{
        selectItem(item){
            //console.log('item selected - ' + item)
            this.itemsScanned[item].selected = !this.itemsScanned[item].selected;
            if(this.isItemSelected(item)){
                let indexToRemove = this.selectedItems.findIndex(x => x.sku == this.itemsScanned[item].sku)
                this.selectedItems.splice(indexToRemove, 1);
            }else{
                this.selectedItems[this.selectedItems.length] = this.itemsScanned[item];
            }
            //console.log('item scanned - ' + item)
            //console.log('selected items - ' + this.selectedItems.length)
            this.updateInd++;
        },
        isItemSelected(item){
            return this.selectedItems.findIndex(x => x.sku == this.itemsScanned[item].sku) == -1 ? false : true
        },
        getSelected(){
            this.itemsScanned.forEach((item) => {
                if (item.selected) {
                    this.selectedItems.push(item);
                }
            });
        },
        clearSelected(){
            this.selectedItems.forEach(item => {
                //console.log('remove - ' + item.sku);
                let result = this.exec_shortShip(item)
                //console.log('shipped?', result)
                this.$store.dispatch('ProductCollection/removeScannedItem', item.sku);
                item.selected = false;
            });
            this.itemsScanned = this.$store.getters["ProductCollection/scannedCollection"];
            this.selectedItems = [];
        },
        exec_shortShip(product){
            let currentMissingSkus = this.missingSkus;
            //console.log(product.sku, ' is missing')
            let missingProduct = {
                name: 'InventoryTransfer',
                req_ref: Math.random().toFixed(10),
                params: {
                    item: product.sku,
                    type: 'INVLOCLOC',
                    quantity: 1,
                    //from_div: this.division,
                    to_div: this.division,
                    //from_site: product.siteId,
                    to_site: this.selectedSite.Id,
                    //from_locid: `${this.division}_${this.currentSite}_${product.loc_id}`,
                    to_locid: `${this.division}_${this.currentSite}_MISS`,
                    //from_proj: product.proj,
                    to_proj: product.proj,
                    //from_locnum: product.loc_num,
                    to_locnum: "SHORTSHIP"
                },
                product: product,
                api_token: 'token'
            };
            const response = this.$store.dispatch('PowerScan/transferInventory', missingProduct)
                .then((response)=>{
                    return response;
                });
        },
        exec_unpick(ItemToUnpick){
        //let orderState = this.$store.getters['PowerScan/currentOrderByBin'] 
            //console.log('Item to unpick - ', ItemToUnpick);
            let pickedItem = {
                name: 'PickItem',
                req_ref: Math.random().toFixed(10),
                product: ItemToUnpick, 
                //bin: `${this.division}_${ItemToUnpick.loc_id}_${ItemToUnpick.loc_num}`,
                params: {
                    rstk__soprod_prod__c: ItemToUnpick.sku,
                    rstk__sydata_sohdr__c: ItemToUnpick.order_Id ,
                    rstk__sydata_txnqty__c: 1,
                    rstk__sydata_txntype__c: 'Sales Order Pick-Pack Reversal',
                    rstk__sydata_sydiv__r: this.division,
                    rstk__sydata_icitem__r: `${this.division}_${ItemToUnpick.sku}`,
                    //rstk__sydata_docno__c: this.timestamp, //timestamp doesn't seem to work
                    rstk__sydata_soline__c: ItemToUnpick.order_line_Id
                }
            }
            let unpickedItemSubmit = {
                    name: pickedItem.name,
                    req_ref: pickedItem.req_ref,
                    params: pickedItem.params,
                    api_token: 'token'
                }
            const response = this.$store.dispatch('PowerScan/transferInventory', unpickedItemSubmit);
        },
    }
}
</script>